"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _Constants = require("composer-plugins/plugins/questionAndAnswer/Constants");

var _getObjectId = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/utils/getObjectId"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _getRelatedObjectProps2 = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/utils/getRelatedObjectProps"));

var _getPropertyValuesFromObject = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/utils/getPropertyValuesFromObject"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _BaseQuestionBlock = _interopRequireDefault(require("./BaseQuestionBlock"));

var _QuestionContainer = _interopRequireDefault(require("./QuestionContainer"));

var _isSupportedPropertyType = _interopRequireDefault(require("composer-plugins/utils/isSupportedPropertyType"));

var ENABLED_OBJECT_TYPES = Object.keys(_Constants.ObjectTypes);

var SubmitQuestionBlock =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SubmitQuestionBlock, _React$Component);

  function SubmitQuestionBlock(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SubmitQuestionBlock);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubmitQuestionBlock).call(this, props));
    _this.handlePropertyChanged = _this.handlePropertyChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmissionChanged = _this.handleSubmissionChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateQuestionEntity = _this.updateQuestionEntity.bind((0, _assertThisInitialized2.default)(_this));
    _this.getRelatedObjectProps = _this.getRelatedObjectProps.bind((0, _assertThisInitialized2.default)(_this));
    _this.debounceOnSubmissionChanged = (0, _debounce.default)(300, _this.props.onSubmissionChanged);
    _this.debounceOnObjectPropertyChanged = (0, _debounce.default)(300, _this.props.onObjectPropertyChanged);
    return _this;
  }

  (0, _createClass2.default)(SubmitQuestionBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          question = _this$props.question,
          setQuestion = _this$props.setQuestion;

      var _this$getRelatedObjec = this.getRelatedObjectProps(),
          relatedObject = _this$getRelatedObjec.relatedObject;

      if (question.isPropertyQuickReply() && question.isValid()) {
        var objectValues = (0, _getPropertyValuesFromObject.default)(relatedObject, question.propertyName);

        if (!objectValues.equals(question.selected)) {
          var updatedQuestion = question.set('selected', objectValues);
          setQuestion(updatedQuestion);
          this.updateQuestionEntity(updatedQuestion);
        }
      }
    }
  }, {
    key: "getRelatedObjectProps",
    value: function getRelatedObjectProps() {
      var _this$props2 = this.props,
          question = _this$props2.question,
          sourceObject = _this$props2.sourceObject,
          sourceObjectType = _this$props2.sourceObjectType,
          enabledAssociations = _this$props2.enabledAssociations,
          associations = _this$props2.associations;
      return (0, _getRelatedObjectProps2.default)(question, sourceObject, sourceObjectType, enabledAssociations, associations);
    }
  }, {
    key: "updateQuestionEntity",
    value: function updateQuestionEntity(question) {
      var editorState = this.props.getEditorState();
      var forceSelection = false;
      var updatedEntityData = question.toJS();
      this.props.onEditorStateChange((0, _draftHelpers.updateEntity)(this.props.entityKey, editorState, updatedEntityData, 'update-entity', forceSelection));
    }
  }, {
    key: "handleSubmissionChanged",
    value: function handleSubmissionChanged(updatedQuestion) {
      if (this.props.question.equals(updatedQuestion)) {
        return;
      }

      this.updateQuestionEntity(updatedQuestion);
      this.props.setQuestion(updatedQuestion);
      this.debounceOnSubmissionChanged(updatedQuestion);
    }
  }, {
    key: "handlePropertyChanged",
    value: function handlePropertyChanged(value) {
      var question = this.props.question;

      var _this$getRelatedObjec2 = this.getRelatedObjectProps(),
          relatedObject = _this$getRelatedObjec2.relatedObject;

      this.debounceOnObjectPropertyChanged({
        objectType: question.objectType,
        objectId: (0, _getObjectId.default)(question.objectType, relatedObject),
        propertyName: question.propertyName,
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          question = _this$props3.question,
          getQuestionAndAnswerEnabled = _this$props3.getQuestionAndAnswerEnabled,
          property = _this$props3.property;

      var _this$getRelatedObjec3 = this.getRelatedObjectProps(),
          relatedObjectError = _this$getRelatedObjec3.relatedObjectError;

      var propertyIsSupported = question.isPropertyQuickReply() && (0, _isSupportedPropertyType.default)(property);
      var isPropertyQuickReplyAndUnsupported = question.isPropertyQuickReply() && !propertyIsSupported;
      var shouldBeDisabled = !getQuestionAndAnswerEnabled() || isPropertyQuickReplyAndUnsupported;
      var alertMessage = null;
      var alertType = null;

      if (isPropertyQuickReplyAndUnsupported) {
        alertMessage = _react.default.createElement(_FormattedMessage.default, {
          message: "composer-plugins.questionAndAnswer.notSupportedType"
        });
        alertType = 'warning';
      }

      return _react.default.createElement(_BaseQuestionBlock.default, {
        question: question,
        objectProperty: property,
        onSubmissionChanged: this.handleSubmissionChanged,
        onPropertyChanged: this.handlePropertyChanged,
        objectPropertyError: isPropertyQuickReplyAndUnsupported ? null : relatedObjectError,
        disabled: shouldBeDisabled,
        alertMessage: alertMessage,
        alertType: alertType
      });
    }
  }]);
  return SubmitQuestionBlock;
}(_react.default.Component);

SubmitQuestionBlock.propTypes = {
  associations: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
  enabledAssociations: _react.PropTypes.instanceOf(_immutable.Set).isRequired,
  getQuestionAndAnswerEnabled: _react.PropTypes.func.isRequired,
  onObjectPropertyChanged: _react.PropTypes.func.isRequired,
  onSubmissionChanged: _react.PropTypes.func.isRequired,
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired,
  property: _react.PropTypes.instanceOf(_immutable.Map),
  sourceObject: _react.PropTypes.instanceOf(_immutable.Record),
  sourceObjectType: _react.PropTypes.oneOf(ENABLED_OBJECT_TYPES),
  entityKey: _react.PropTypes.string.isRequired,
  getEditorState: _react.PropTypes.func.isRequired,
  onEditorStateChange: _react.PropTypes.func.isRequired,
  setQuestion: _react.PropTypes.func.isRequired
};

var _default = (0, _QuestionContainer.default)(SubmitQuestionBlock);

exports.default = _default;
module.exports = exports.default;